// Maximum breakpoint width.
// The maximum value is reduced by 0.02px to work around the limitations of
// `min-` and `max-` prefixes and viewports with fractional widths.
// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
// See https://bugs.webkit.org/show_bug.cgi?id=178261
const breakpoints = {
  xxs: [0, 399.8],
  xs: [400, 599.8],
  sm: [600, 1023.8],
  md: [1024, 1439.8],
  lg: [1440, 1919.8],
  xl: [1920, null]
};
function min(bp) {
  return breakpoints[bp][0];
}
function max(bp) {
  return breakpoints[bp][1];
}
function mq(direction, bp, bp2) {
  switch (direction) {
    case 'up':
      return `(min-width: ${min(bp)}px)`;
    case 'down':
      if (bp === 'xl') {
        // Selected breakpoint is the largest breakpoint, only be concerned with min-width
        return `(min-width: 0px)`;
      }
      return `(max-width: ${max(bp)}px)`;
    case 'only':
      if (bp === 'xl') {
        // Selected breakpoint is the largest breakpoint, only be concerned with min-width
        return `(min-width: ${min(bp)}px)`;
      }
      return `(min-width: ${min(bp)}px) and (max-width: ${max(bp)}px)`;
    case 'between':
      if (bp2 === 'xl') {
        // Selected max breakpoint is the largest breakpoint, only be concerned with min-width
        return `(min-width: ${min(bp)}px)`;
      }
      return `(min-width: ${min(bp)}px) and (max-width: ${max(bp2)}px)`;
  }
}

export { mq as m };
